import { httpCreate } from './http';

const http = httpCreate('/srv/official-pay-account');

/* 企业版新增 */
export const officialPayAccount = {
	saveOfficialPayAccount(data) {
		return http.post(``, data);
	},
	//上传证书
	upload(data) {
		return http.post(`/upload`, data);
	},
};
